module.exports = __webpack_public_path__ + "static/media/united-states-of-america-flag-medium.599891f8.png";